import { ApiProject, ApiSimpleComponent } from "@incendium/api";
import { personalisationService } from "Apis";
import { useProjectSharedState } from "Hooks/useSharedState";

const fetch = async (selectedProject: ApiProject | null) => {
    if (selectedProject) {
        const res =
            await personalisationService.personalisationServiceListLanderComponentComponents(
                {
                    projectId: selectedProject.id as number,
                }
            );
        return res.components || [];
    }
    return [];
};

export const useLanderLandingComponents = () => {
    const { state, setState, loading, refetch, fetched } = useProjectSharedState<
        ApiSimpleComponent[]
    >("landerLandingComponents", [], fetch);

    return {
        components: state,
        setComponents: setState,
        loading,
        refetch,
        fetched,
    };
};
